import { GetType, PostType, Tax } from "..";
import * as CallType from "../CallType";

export interface GetAll extends GetType {
	Res: {
		countries: Tax.CountryType[];
		taxes: Tax.TaxType[];
	}
}

export interface EditCountry extends PostType {
	Body: {
		country: Tax.CountryType,
	}
}
export interface EditTax extends PostType {
	Body: {
		tax: Tax.TaxType,
	}
}
export interface Add extends PostType {
	Body: {
		country: Omit<Tax.CountryType, "tax_id">,
		taxes: Tax.TaxType[],
	}
}
export interface DeleteTax extends PostType<"bad tax destination"> {
	Body: {
		tax_id: number;
		merge_tax_id?: number;
		country: string;
	}
}
export interface CurrencyCodes extends GetType {
	Res: {
		codes: string[];
	}
}

export const Call = {
	getAll: CallType.Get<GetAll>("/staff/tax/getAll"),
	editCountry: CallType.Post<EditCountry>("/staff/tax/editCountry"),
	editTax: CallType.Post<EditTax>("/staff/tax/editTax"),
	add: CallType.Post<Add>("/staff/tax/add"),
	deleteTax: CallType.Post<DeleteTax>("/staff/tax/deleteTax"),
	currencyCodes: CallType.Get<CurrencyCodes>("/staff/tax/currencyCodes"),
};

